export default {"src":"/_next/static/media/entreprise_100_pour_100_FR_dscktop.6a669878.svg","height":151,"width":148};